<div class="alert alert-danger m-3" *ngIf="loadError">
  <strong>{{ 'devicesErrorConnectingServerTitle' | translate }}</strong>
  <div>{{ 'devicesErrorConnectingServerSubTitle' | translate }}</div>
</div>

<div *ngIf="device.includes('EVVC')">
  <app-charger [serial]="device"></app-charger>
</div>

<div *ngIf="device.includes('CTM')">
  <app-smart-ctm [serial]="device"></app-smart-ctm>
</div>

<div *ngIf="subtype === 'datalog+'">
  <app-d2 [serial]="device"></app-d2>
</div>

<div *ngIf="subtype === 'anc+'">
  <app-a2 [serial]="device"></app-a2>
</div>

<div *ngIf="subtype && (subtype === 'astro_lum' || device.startsWith('M1'))">
  <app-astro-lum [serial]="device"></app-astro-lum>
</div>

<div *ngIf="device.includes('ANC2') && !device.includes('A1')">
  <app-anc2 [serial]="device"></app-anc2>

</div>

<div *ngIf="device.includes('XLUM')">
  <app-xlum [serial]="device"></app-xlum>
</div>
